/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TrackVisitResponse interface.
 */
export function instanceOfTrackVisitResponse(value) {
    if (!('visitToken' in value) || value['visitToken'] === undefined)
        return false;
    return true;
}
export function TrackVisitResponseFromJSON(json) {
    return TrackVisitResponseFromJSONTyped(json, false);
}
export function TrackVisitResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'visitToken': json['visit_token'],
    };
}
export function TrackVisitResponseToJSON(json) {
    return TrackVisitResponseToJSONTyped(json, false);
}
export function TrackVisitResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'visit_token': value['visitToken'],
    };
}
